import React, { useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
  Button, FormControl, FormLabel, Textarea, Text,
} from "@chakra-ui/react";
import ColleaguePicker from "./ColleaguePicker";

const COPY = {
  reject: {
    title: "Reject", confirm: "Reject", colorScheme: "red",
    placeholder: "Let them know why you're rejecting it",
    note: "It goes back to the person who assigned it.",
  },
  reassign: {
    title: "Reassign", confirm: "Reassign", colorScheme: "blue",
    placeholder: "Let them know why it's coming to them",
    note: "The person who assigned it still confirms when it's done.",
  },
  cancel: {
    title: "Cancel task", confirm: "Cancel task", colorScheme: "red",
    placeholder: "Why isn't it needed any more?",
    note: "The task closes for everyone on it.",
  },
  unassign: {
    title: "Unassign order", confirm: "Unassign", colorScheme: "red",
    placeholder: "Why is it going back unassigned?",
    note: "It goes back to the patient's Orders & followups list as unassigned.",
  },
};

// The window behind Reject / Reassign / Cancel / Unassign: an optional message
// for the activity feed and, to reassign, who it goes to. onSubmit resolves
// false to keep the window open (the action failed).
export default function WorkItemDecisionModal({ action, item, schema, onClose, onSubmit }) {
  const copy = COPY[action] || COPY.reject;
  const [message, setMessage] = useState("");
  const [person, setPerson] = useState(null);
  const [busy, setBusy] = useState(false);
  const needsPerson = action === "reassign";

  const submit = async () => {
    setBusy(true);
    try {
      const ok = await onSubmit({ message: message.trim(), toUser: person });
      if (ok !== false) onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} size="md" blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader pr={10}>
          {copy.title}
          {item?.title && (
            <Text fontSize="sm" fontWeight="normal" color="gray.600" noOfLines={2}>{item.title}</Text>
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {needsPerson && <ColleaguePicker label="Reassign to" picked={person} onPick={setPerson} schema={schema} />}
          <FormControl>
            <FormLabel>Message (optional)</FormLabel>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder={copy.placeholder}
                      maxLength={4000} rows={3} />
          </FormControl>
          <Text fontSize="sm" color="gray.500" mt={2}>{copy.note}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>Back</Button>
          <Button colorScheme={copy.colorScheme} onClick={submit} isLoading={busy} isDisabled={needsPerson && !person}>
            {copy.confirm}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
